import {writable} from 'svelte/store';

const {set, update, subscribe} = writable({
    device: 'xs',
    docWidth: 0,
    docHeight: 0,

    clientChanged: false,
    selectedClientId: null,
    editClientId: null,

    // sent messages
    selectedSentId: null,

    // credits history
    selectedCreditsHistoryId: null,
    creditsHistoryClient: null,
});

const app = {
    set, update, subscribe,
    windowResize: () => {
        app.update(obj => {
            let win = window;
            let doc = document;
            let docElem = doc.documentElement;
            let body = doc.getElementsByTagName('body')[0];
            obj.docWidth = win.innerWidth || docElem.clientWidth || body.clientWidth;
            obj.docHeight = win.innerHeight || docElem.clientHeight || body.clientHeight;

            if (obj.docWidth > 1199) {
                obj.device = "lg";
            } else if (obj.docWidth > 991) {
                obj.device = "md";
            } else if (obj.docWidth > 767) {
                obj.device = "sm";
            } else {
                obj.device = "xs";
            }

            return obj;
        })
    },
    clientChange: value => { // call from ClientEdit on save
        update(state => {
            state.clientChanged = value;
            return state;
        });
    },
    selectClient: id => {
        update(state => {
            state.selectedClientId = id;
            return state;
        });
    },
    editClient: id => {
        update(state => {
            if (id) {
                state.selectedClientId = id;
            }
            state.editClientId = id;
            return state;
        });
    },
    clientCreditsHistory: client => {
        update(state => {
            if (client !== null) {
                state.selectedClientId = client.id;
            }
            state.selectedCreditsHistoryId = null;
            state.creditsHistoryClient = client;
            return state;
        });
    },
    selectSmsSent: id => {
        update(state => {
            state.selectedSentId = id;
            return state;
        });
    },
}
export default app;